module.exports = __webpack_public_path__ + "static/media/SpaceMono-Italic.233cc83b.ttf";